import * as Yup from "yup";

export const initialValues = {
  name: "",
  description: "",
  code: "",
  sort_order: "",
  color_hex: "",
};

export const getValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().nullable(),
    code: Yup.string().nullable(),
    sort_order: Yup.number()
      .transform((value, original) =>
        original === "" || original === null || original === undefined
          ? null
          : value,
      )
      .nullable()
      .integer("Sort order must be a whole number"),
    color_hex: Yup.string()
      .nullable()
      .test(
        "hex",
        "Use a valid hex color (e.g. #AABBCC)",
        (value) =>
          !value ||
          value.trim() === "" ||
          /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value.trim()),
      ),
  });
